<template>
    <div name="home" class="home">
        <img style="width: 32.8vw;margin-top: 12vh;" src="../../../assets/showcase/kocom/main_logo.png" />
        <div class="button1" style="margin-top: 8vh;" @click="gopreview">
            <img style="width: 15.2vw;" src="../../../assets/showcase/kocom/button.png" />
            <span><span style="font-weight: 700;">헬스케어 서비스</span><br>미리보기</span>
        </div>
        <div class="button1" style="margin-top: 3vh;" @click="gosignup">
            <img style="width: 16vw;" src="../../../assets/showcase/xi/button1.png" />
            <span style="width: 35vw; text-align: center;"><span style="font-weight: 700;">건강측정</span><br>체험하기</span>
        </div>

        <div style="display: flex;justify-content: flex-start; align-items: center; gap: 3vw;margin-top: 8vh;">
            <img style="width: 4vw;" src="../../../assets/showcase/xi/pointer.png" />
            <span class="text">원하시는 메뉴를 선택하세요</span>
        </div>
        <span class="copyright">ⓒsoldoc.co.kr All rights reserved.</span>
    </div>
</template>

<script>
import homeMixin from './homeMixin'

export default {
    name: 'KocomHOme',
    mixins: [homeMixin]
}
</script>

<style scoped>
    .home {
        width: 100%;
        height: 100dvh;
        background: var(--xi-beige, #9CB5FF);
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .button1 {
        border-radius: 16px;
        background: var(--xi-navy, #004EA2);
        box-shadow: 8px 8px 16px 0 rgba(139, 185, 215, 0.40) inset, 8px 8px 8px 0 rgba(0, 0, 0, 0.25);
        width: 71vw;
        aspect-ratio: 1/0.59;
        font-size: 5.9vw;
        line-height: 120%;
        color: var(--xi-gray-0, #FFF);
        font-family: "Pretendard Variable";
        font-style: normal;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 5.8vw;
    }
    .copyright {
        position: absolute;
        bottom: 3vh;
        font-size: 2.8vw;
        color: var(--theme-main);
        font-family: "Pretendard Variable";
        font-weight: 400;
        opacity: 0.6;
    }
    .text {
        font-size: 3.3vw;
        color: var(--theme-main);
        text-align: center;
        font-family: "Pretendard Variable";
        font-style: normal;
        font-weight: 600;
        line-height:  300%;
        letter-spacing: -1.92px;
        height: 5vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/showcase/home/KocomHome.vue